// extracted by mini-css-extract-plugin
module.exports = {"icon":"skillIcon-module--icon--29avs","iconDimmed":"skillIcon-module--iconDimmed--2PWKf","img":"skillIcon-module--img--DIu82"};